export default {
    path: 'tag-review',
    component: () => import('../tagReview.vue'),
    children: [
        {
            path: '',
            name: 'Thẻ đánh giá',
            component: () => import('../table/Table.vue')
        }
    ],
};